import React, { useEffect, useState } from "react";
import dass from "../assets/images/dass.png";

import { Link } from "react-router-dom";
import database from "../firebase";

const Profile = () => {
  const [resume, setResume] = useState("");

  useEffect(() => {
    database
      .collection("mycv")
      .onSnapshot((snapshot) =>
        setResume(snapshot.docs.map((doc) => doc.data().imageUrl))
      );
  }, []);

  return (
    <div className="px-5 py-3 bg-gray-800 lg:h-[110]">
      <div>
        <div className="flex justify-center shadow-sm py-2">
          <img src={dass} alt="" className=" rounded-full h-32" />
        </div>
        <h1 className="text-center mt-2 mb-3 text-gray-200 text-lg tracking-wider">
          Pavan Rathod
        </h1>

        <div className="flex justify-center text-white shadow-lg p-3 md:w-2/3 lg:w-1/2  sm:ml-auto sm:mr-auto">
          <h1 className="text-sm tracking-wider sm:text-lg text-gray-100">
            I live and work near Bangalore, India. At my day job, I develop
            ReactJs websites. I also freelance when I can, mostly building
            custom websites and apps that you can’t get from a template. I have
            1.5 years of experience in full stack web dev, I completed diploma
            in computer science and engineering 2016 for more..
          </h1>
        </div>
        <div className="text-white flex justify-center mt-2">
          <a
            href={resume}
            download="pavanCV"
            target="_blank"
            rel="noopener noreferrer"
            className=" border border-gray-200 px-3 focus:outline-none py-1 hover:bg-gray-200 tracking-wider hover:text-black"
          >
            Download Resume
          </a>
        </div>
        <h1 className="text-center tracking-wider mt-3 text-sm sm:text-lg text-gray-400">
          Passion
        </h1>
        <div className=" text-white p-3 text-base flex justify-center shadow-lg md:w-2/3 lg:w-1/2 sm:ml-auto sm:mr-auto">
          <h2>
            My place in the world seems to be at the intersection of creativity
            and logic. All projects are a problem to be solved, whether it’s to
            do with design or code—only the tools change. My process is
            iterative; I approach each problem as a learning experience that
            informs the rest of the project, which means that I tend to not rely
            on full design mockups.
          </h2>
        </div>
        <h1 className="text-center tracking-wider font-semibold text-lg text-gray-400 mt-3">
          Designing skills
        </h1>
        <div className=" text-white text-base flex justify-center shadow-lg p-3 md:w-2/3 lg:w-1/2 sm:ml-auto sm:mr-auto">
          <h1>
            While my focus is mobile-first responsive websites with HTML,
            JavaScript, CSS (Tailwind). I handle most backend stuff with MySQL
            and PostgreSQL along with NodeJs SQL package, very familiar with
            NoSQL firebase, React-Redux state management, PERN stack
            development, ReactJs with Firebase, very much interested in RESTful
            api's
          </h1>
        </div>
        <div className="flex justify-center mt-6 mb-5">
          <Link to="/projects">
            <button className="px-4 py-2 tracking-wider shadow-sm text-white border border-gray-50 hover:bg-gray-50 hover:text-black  font-semibold rounded-sm  text-base focus:outline-none">
              {" "}
              View Apps{" "}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Profile;
